<template>
  <v-card>
    <v-card-title>
      <h2 class="headline">{{ qid(currentQuestion).question }}</h2>
    </v-card-title>
    <v-divider class="mb-3">
    </v-divider>
    <v-card-text>
      <v-slider
        v-model="slider"
        :tick-labels="getTicksLabels()"
        :max="100"
        :min="1"
        step="1"
        ticks="always"
        tick-size="2"
        thumb-label="always"
        color="orange lighten-2">
        <template slot="thumb-label" slot-scope="props">
          <span>
                  
          </span>
        </template>          
      </v-slider>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "MetsankayttajaSlider",
  computed: {
    ...mapState("metsankayttaja", ["currentQuestion"]),
    ...mapGetters("metsankayttaja", ["qid"]),
    slider: {
      get () {
        return this.$store.state.metsankayttaja.answers[this.currentQuestion]       
      },
      set (value) {
        this.$store.commit('metsankayttaja/UPDATE_ANSWER', value);
      }
    }
  },
  methods: {
    getTicksLabels() {
      let labels = this.qid(this.currentQuestion).answers.reduce(
        (acc, curr) => {
          acc.push(curr.text);
          return acc;
        },
        []
      );
      let return_labels = Array(100).fill("");
      return_labels[0] = labels[0];
      return_labels[49] =
        this.qid(this.currentQuestion).id !== 2 ? "" : labels[1];
      return_labels[99] = labels[2];
      /*
      if (this.qid(this.currentQuestion).id === 2) {
        return labels;
      }*/
      labels[1] = "";
      return return_labels;
    },
    change(q, a) {
      this.$store.dispatch("metsankayttaja/addAnswer", {
        question: q,
        answer: a
      });
    }
  },
  mounted() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.align-slider-text {
  float: right;
  margin-right: 15px;
}

.unselected {
  opacity: 0.2;
}

.bgwhite {
  background: white;
}
</style>
